export const LOADING_STRATEGY = "LOADING_STRATEGY"
export const FETCH_STRATEGY = "FETCH_STRATEGY"
export const FETCH_STRATEGY_FAIL = "FETCH_STRATEGY_FAIL"
export const PATCH_STRATEGY = "PATCH_STRATEGY"
export const PATCH_STRATEGY_FAIL = "PATCH_STRATEGY_FAIL"
export const CLEAR_STRATEGY = "CLEAR_STRATEGY"
